import Accion from "./Accion";

export default Accion;
